import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {BonusBunniesGameMode} from "../../gamemode/BonusBunniesGameMode";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {BonusBunniesParsedGameData} from "../../server/data/BonusBunniesParsedGameData";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {BonusBunniesGameConfig} from "../../BonusBunniesGameConfig";
import {BonusBunniesReelController} from "../../reel/BonusBunniesReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {BonusBunniesGameModuleConfig} from "../../BonusBunniesGameModuleConfig";
import {BonusBunniesSoundConfig} from "../../BonusBunniesSoundConfig";

/**
 * Created by Jerker Nord on 2020-05-19.
 */

export class BonusBunniesBonusGameNearWinUntilWinController extends ReelStopPresentationController {

    private _bonusSpinsRemaining:number;
    private _lastBonusSymbolPositionExcitement:number[];
    private _nextMode:string;
    private _firstValuePosition:number;
    private _nearWinActivated:boolean;

    constructor(index:number) {
        super(index, "BonusBunniesBonusGameNearWinUntilWinController");
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onBeforeSpinStart());
        EventHandler.addEventListener(this, SpinEvent.STOPPED, (event:GameEvent) => this.onSpinStopped());
    }

    protected parseFeatureGameData(data:BonusBunniesParsedGameData):void {
        this._lastBonusSymbolPositionExcitement = data.lastBonusSymbolPositionExcitement;
        this._bonusSpinsRemaining = data.bonusSpinsRemaining;
        this._nextMode = data.nextMode;
        this._firstValuePosition = -1;
        for(let i:number = 0; i < data.bonusNewPositions.length; i++) {
            for(let j:number = 0; j < data.bonusNewPositions[i].length; j++) {
                if(data.bonusNewPositions[i][j] == true) {
                    this._firstValuePosition = (i * 5) + j;
                    break;
                }
            }
        }
    }

    private onSpinStopped():void {
        if(this._nearWinActivated == true) {
            this._nearWinActivated = false;
            for(let i:number = 0; i < BonusBunniesGameConfig.instance.REELS_NUM; i++) {
                (<BonusBunniesReelController>Reels.getReel(i)).resetStopDelay();
            }
        }
    }

    private onBeforeSpinStart():void {
        this._firstValuePosition = -1;

        if(this._bonusSpinsRemaining == 1) {
            BonusBunniesSoundConfig.instance.REELS_SPINNING_START_ON_SPIN_START = BonusBunniesSoundConfig.instance.REELS_SPINNING_LAST_SPIN_BONUS;
        } else {
            BonusBunniesSoundConfig.instance.REELS_SPINNING_START_ON_SPIN_START = BonusBunniesSoundConfig.instance.REELS_SPINNING_DEFAULT;
        }
        if(this._nextMode == BonusBunniesGameMode.BONUS_GAME && this._bonusSpinsRemaining == 1 && this._lastBonusSymbolPositionExcitement[0] < 0) {
            this._nearWinActivated = true;
            let delay:number = 0.5;
            if(BonusBunniesGameModuleConfig.bonusBunniesSpinController.getNumberOfActiveReels() < 4) {
                delay = 1;
            } else if(BonusBunniesGameModuleConfig.bonusBunniesSpinController.getNumberOfActiveReels() < 7) {
                delay = 0.8;
            }
            EventHandler.dispatchEvent(new GameEvent(ReelEvent.REEL_ADD_STOP_DELAY, {
                reelId : 0,
                delay : delay
            }));
        }
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(this._nearWinActivated == true && this._firstValuePosition > 0) {
            if(data.reelId == this._firstValuePosition - 1) {
                const reelsToSpin:boolean[] = BonusBunniesGameModuleConfig.bonusBunniesSpinController.reelsToSpinBonusGame;
                let delay:number = 0.2;
                let reelCount:number = 1;
                if(GameSetting.isFastSpin == true) {
                    delay = BonusBunniesGameConfig.instance.REEL_QUICK_STOP_DELAY;
                }
                for(let i:number = data.reelId; i < BonusBunniesGameConfig.instance.REELS_NUM; i++) {
                    if(reelsToSpin[i] == true) {
                        (<BonusBunniesReelController>Reels.getReel(i)).setStopDelay(delay * reelCount);
                        reelCount++;
                    }
                }
            }
        }
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        this.dispatchCompleteEvent(data.reelId);
    }
}